// ── Temporary on-screen drag/drop diagnostic ────────────────────────────────
// Shows a small toast describing exactly what happens on each drop, so we can
// pinpoint failures inside the HappySpace platform/editor where devtools aren't
// available. Remove once drag-swap is confirmed working on the platform.
//
// Enabled by default; set localStorage.dds_drag_debug = "0" to silence.
export function dragDebug(msg: string, color = "#082f6d") {
  try {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("dds_drag_debug") === "0") return;
    let el = document.getElementById("dds-drag-debug") as HTMLDivElement | null;
    if (!el) {
      el = document.createElement("div");
      el.id = "dds-drag-debug";
      el.style.cssText =
        "position:fixed;left:12px;bottom:12px;z-index:2147483647;max-width:92vw;" +
        "font:600 12px/1.45 -apple-system,Segoe UI,sans-serif;color:#fff;padding:8px 12px;" +
        "border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.3);white-space:pre-wrap;pointer-events:none;";
      document.body.appendChild(el);
    }
    el.style.background = color;
    el.style.opacity = "1";
    el.style.transition = "none";
    el.textContent = "🔧 " + msg;
    const prev = (el as any).__t;
    if (prev) clearTimeout(prev);
    (el as any).__t = setTimeout(() => {
      if (el) {
        el.style.transition = "opacity .5s";
        el.style.opacity = "0";
      }
    }, 7000);
  } catch {
    /* ignore */
  }
}
